import plMessages from 'ra-language-polish';

const pl = {
    ...plMessages,
    resources: {
        events: {
            name: 'Wydarzenie |||| Wydarzenia',
            fields: {
                title: "Tytuł",
                category: "Kategoria",
                country_id: "Kraj",
                region_id: "Region",
                start_at: "Rozpoczęty",
                end_at: "Zakończony",
                online: "Online",
                on_site: "Na miejscu",
                lat: "Szerokość geograficzna",
                lng: "Długość geograficzna",
                address: "Adres",
                organization_name: "Nazwa organizacji",
                organization_website: "Strona internetowa organizacji",
                organization_contact_info: "Dane kontaktowe organizacji",
                intro: "Wstęp",
                content: "Treść",
                status: "Status",
                published: "Opublikowane"
            }
        },
        account: {
            fields: {
                firstname: "Imię",
                lastname: "Nazwisko",
                password: "Hasło",
                job_title: "Nazwa stanowiska",
                organization_name: "Nazwa organizacji",
                organization_address: "Adres organizacji",
                organization_website: "Strona internetowa organizacji",
                organization_contact_name: "Nazwa osoby kontaktowej w organizacji",
                organization_contact_email: "E-mail kontaktowy organizacji",
            }
        }
    },
    'Total': "Suma",
    'My upcoming event(s)': "Nadchodzące wydarzenia",
    'Join us and create an event': "Dołącz do nas i stwórz wydarzenie",
    'Once your event is created the Europe Members team will review your event. If everything is in order, you will be prompted by e-mail and you will be able to publish your event.': "Po utworzeniu wydarzenia zespół Europe Remembers dokona jego przeglądu. Jeśli wszystko jest w porządku, zostaniesz powiadomiony przez e-mail i będziesz mógł opublikować swoje wydarzenie.",
    'Create event': "Utwórz wydarzenie",
    'Search': "Szukaj",
    'Country': "Kraj",
    'Region': "Region",
    'Published': "Opublikowane",
    'Online': "Wydarzenie online",
    'On site': "Wydarzenie na miejscu",
    'Draft': "Szkic",
    'Review': "Weryfikacja",
    'Accepted': "Zaakceptowane",
    'Refused': "Odrzucone",
    'Commemoration': "Obchody",
    'Conference': "Konferencja",
    'Festival': "Festiwal",
    'Guided tour': 'Wycieczka z przewodnikiem',
    'Exhibition': "Wystawa",
    'Music-Theater': 'Muzyka - Teatr',
    'Other': "Inne",
    'Ask for review': "Prześlij do weryfikacji",
    'Do you want to ask a review for the event': "Czy chcesz przesłać wydarzenie do weryfikacji?",
    'Unpublish': "Cofnij publikację",
    'Do you want to unpublish the event': "Czy chcesz cofnąć publikację?",
    'Event published': "Wydarzenie opublikowane",
    'Event unpublished': "Publikacja wydarzenia cofnięta",
    'Publish': "Opublikuj",
    'Do you want to publish the event': "Czy chcesz opublikować wydarzenie?",
    'Summary': "Streszczenie",
    'Translations': "Tłumaczenia",
    'Pictures': "Zdjęcia",
    'Title': "Tytuł",
    'Intro': "Wstęp",
    'Content': "Treść",
    'Picture': "Zdjęcie",
    'Description': "Opis",
    'Copyright': "Prawa autorskie",
    'Featured': "Przedstawione",
    'Account': "Konto",
    'Account updated': "Zaktualizowano informacje",
    'Forgot password?': "Nie pamiętasz hasła?",
    'Forgot password': "Nie pamiętam hasła",
    'An email has been sent': "Wysłano wiadomość e-mail",
    'Email': "e-mail",
    'Reset password': "Resetowanie hasła",
    'Main picture': "Zdjęcie główne",
    'Default language': "Język domyślny",
    'Event website': "Strona internetowa wydarzenia",
    'Europe Remembers : How to create an event ?': " Europe Remembers: Jak utworzyć wydarzenie?",
    'Turn on subtitles (CC) to get instructions in your language.': "Włącz napisy (CC), aby uzyskać instrukcje w swoim języku.",
    'Contribute to the project!': 'Wesprzyj \nprojekt!',
    'Europe Remembers aims to give visibility to your events and is free to use ! However we need your contributions to help us maintain and keep this platform running.': 'Europe Remembers zapewnia zwiększoną widoczność wydarzeń i jest bezpłatne! Potrzebujemy jednak Twojego wsparcia, aby utrzymać tę platformę.'
};

export default pl;